var path = 'app/scripts/modules/kubernetes/src/v2/manifest/showManifestYaml.html';
var html = "<div modal-page>\n  <modal-close dismiss=\"$dismiss()\"></modal-close>\n  <div class=\"modal-header\">\n    <h3>{{manifestTitle}}</h3>\n  </div>\n  <form role=\"form\">\n    <div class=\"modal-body\">\n      <textarea readonly=\"readonly\" rows=\"15\" class=\"code\">{{manifestData}}</textarea>\n    </div>\n    <div class=\"modal-footer\">\n      <button class=\"btn btn-primary\" ng-click=\"$close()\">Close</button>\n    </div>\n  </form>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/kubernetes/src/v2/manifest/showManifestYaml.html
// module id = 1530
// module chunks = 0